// @flow
import DetailsSolo from './DetailsSolo';

export default DetailsSolo;
